/* eslint-disable */

var searchCache = {},
previousSearches = [],
ALPHANUMERIC_REGEX = /[^A-Z0-9]/ig,
selectedSuggestion = {
  fullText: '',
  headingText: '',
  subHeadingText: '',
  postCode: '',
  feedbackLocation: '',
  isFound: false,
  isCached: false,
  inputMethodIsGeoCode: false,
  inputTypeIsPostCode: false,
  valueDisplayed: '',
  coordinates: ''
};

function sanitizeInputText(str) {
  if (!str) return str;

  return str
    .trim()
    .replace(ALPHANUMERIC_REGEX, " ")
    .toUpperCase();
}

function getPreviousSearches() {
  var ret = [];
  // todo: remove this function soon, only hear to remove previous values in dev!
  CleanupLegacyPreviousSuggestions();
  if (localStorage.previousSearch1 !== undefined) {
    ret[0] = localStorage.previousSearch1;
  }
  if (localStorage.previousSearch2 !== undefined) {
    ret[1] = localStorage.previousSearch2;
  }
  return ret;
}

function populatePreviousSearches(text) {
  if (localStorage.previousSearch1 !== undefined) {
    previousSearches[0] = localStorage.previousSearch1;
  }
  if (localStorage.previousSearch2 !== undefined) {
    previousSearches[1] = localStorage.previousSearch2;
  }
  if(previousSearches.indexOf(text) < 0) {
    previousSearches.push(text);
    if (previousSearches.length > 2) {
      previousSearches.splice(0, 1);
    }
    localStorage.setItem('previousSearch1', previousSearches[0]);
    if (previousSearches.length > 1) {
      localStorage.setItem('previousSearch2', previousSearches[1]);
    }
  }
}

function addSelectedSuggestionToPreviousSearches() {
  var text;
  if (selectedSuggestion.headingText && selectedSuggestion.subHeadingText) {
    text = selectedSuggestion.headingText + ', ' + selectedSuggestion.subHeadingText;
  }
  if (window.isLocalStorageWorking) {
    populatePreviousSearches(text);
  }
}

function resetSelectedSuggestion() {
  selectedSuggestion.fullText = '';
  selectedSuggestion.headingText = '';
  selectedSuggestion.subHeadingText = '';
  selectedSuggestion.postCode = '';
  selectedSuggestion.feedbackLocation = '';
  selectedSuggestion.isFound = false;
}

// todo: remove this function soon, only hear to remove previous values in dev!
function CleanupLegacyPreviousSuggestions() {
  if ((localStorage.previousSearch1 && localStorage.previousSearch1.indexOf(',') < 0) ||
    (localStorage.previousSearch2 && localStorage.previousSearch2.indexOf(',') < 0)) {
      localStorage.removeItem('previousSearch1');
      localStorage.removeItem('previousSearch2');
  }
}

function setCache(key, results) {
  searchCache[sanitizeInputText(key)] = results;
}

function getCache(key) {
  return searchCache[sanitizeInputText(key)];
}

module.exports = {
  getPreviousSearches: getPreviousSearches,
  populatePreviousSearches: populatePreviousSearches,
  setCache: setCache,
  getCache: getCache,
  sanitizeInputText: sanitizeInputText,
  selectedSuggestion: selectedSuggestion,
  addSelectedSuggestionToPreviousSearches: addSelectedSuggestionToPreviousSearches,
  resetSelectedSuggestion: resetSelectedSuggestion
};
